/**
 See main methods in Service class
 - If you need special methods create new file that extend Service
 - Otherwise create an instance directly in this file
 **/

import http from './http'
import Service from './Service'
import * as URLS from './apiUrls'

// import class of special methods wich extend Service
import AccessService from './AccessService'
import AdvService from './AdvService'
import AuthService from './Auth'
import ContactService from './ContactService'
import CurrentUserService from './CurrentUserService'
import DebugService from './DebugService'
import DenunciationService from './DenunciationService'
import EventService from './EventService'
import GroupService from './GroupService'
import LotService from './LotService'
import OriginService from './OriginService'
import PoleService from './PoleService'
import ProgramService from './ProgramService'
import StatisticService from './StatisticService'
import UploadService from './UploadService'
import UserService from './UserService'
import LeadService from './LeadService'

// new instance of Service
class AnnexTypeService extends Service {}
class CalendarEventService extends Service {}
class CompanyService extends Service {}
class ExternalAccessService extends Service {}
class FluxService extends Service {}
class OptionService extends Service {}
class ProfilService extends Service {}
class PromoteurService extends Service {}
class ProposalService extends Service {}
class RdvService extends Service {}
class ReminderService extends Service {}
class SearchService extends Service {}
class StateService extends Service {}

class Api {
  constructor ({host}) {
    this.host = host
    this.axios = http.getAxiosInstance(host)
    this.accessService = new AccessService({host, url: URLS.ACCESS})
    this.advService = new AdvService({host, url: URLS.ADV})
    this.annexTypeService = new AnnexTypeService({host, url: URLS.ANNEX_TYPE})
    this.authService = new AuthService({host})
    this.calendarEventService = new CalendarEventService({host, url: URLS.CALENDAR_EVENT})
    this.companyService = new CompanyService({host, url: URLS.COMPANY})
    this.contactService = new ContactService({host, url: URLS.CONTACT})
    this.currentUserService = new CurrentUserService({host, url: URLS.ME})
    this.debugService = new DebugService({host})
    this.denunciationService = new DenunciationService({host, url: URLS.DENUNCIATION})
    this.eventService = new EventService({host, url: URLS.EVENT})
    this.externalAccessService = new ExternalAccessService({host, url: URLS.EXTERNAL_ACCESS})
    this.fluxService = new FluxService({host, url: URLS.FLUX})
    this.groupService = new GroupService({host})
    this.lotService = new LotService({host, url: URLS.LOT})
    this.optionService = new OptionService({host, url: URLS.OPTION})
    this.originService = new OriginService({host, url: URLS.ORIGIN})
    this.poleService = new PoleService({host, url: URLS.POLES})
    this.profilService = new ProfilService({host, url: URLS.PROFIL})
    this.programService = new ProgramService({host, url: URLS.PROGRAM})
    this.promoteurService = new PromoteurService({host, url: URLS.PROMOTEUR})
    this.proposalService = new ProposalService({host, url: URLS.PROPOSAL})
    this.reminderService = new ReminderService({host, url: URLS.REMINDER})
    this.rdvService = new RdvService({host, url: URLS.CALENDAR})
    this.searchService = new SearchService({host, url: URLS.SEARCH})
    this.stateService = new StateService({host, url: URLS.STATES})
    this.statisticService = new StatisticService({host, urlos: URLS.STATISTICS})
    this.uploadService = new UploadService({host, url: URLS.UPLOAD})
    this.userService = new UserService({host, url: URLS.USER})
    this.leadService = new LeadService({host, url: URLS.LEAD})
  }

  setToken (token) {
    this.token = 'Bearer ' + token
    this.axios.defaults.headers['Authorization'] = this.token
  }

  setAppHost (appHost) {
    this.axios.defaults.headers['APPHOST'] = appHost
  }
}

const install = function (Vue, options) {
  const api = new Api(options)
  Vue.prototype.$api = api
  Vue.$api = api
}

export default {
  Api,
  install,
  AuthService,
  PromoteurService,
  CompanyService,
  UserService,
  ProgramService,
  ProfilService,
  LotService,
  UploadService,
  GroupService,
  AccessService,
  OptionService,
  SearchService,
  DenunciationService,
  ProposalService,
  CalendarService: RdvService,
  PoleService,
  ReminderService,
  FluxService
}



// WEBPACK FOOTER //
// ./src/services/api/index.js